import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router'
import Layout from '../../components/layouts/Layout'
import UploadFile from '../../hook/UploadFile'
import http, { URL_S3 } from '../../config/BaseUrl'
import MicrositeModal from '../events/components/Modal/MicrositeModal'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import HeaderTrackingModal from '../events/components/Modal/HeaderTrackingModal'


const MicroSiteEdit = () => {
    const history = useHistory()
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [microSite, setMicroSite] = useState(null)
    const [microSiteData, setMicrositeData] = useState(null)
    const [my_social_gallery_id, setSocialMyTemplateId] = useState(null)
    const [socialTemplateType, setEmailTemplateType] = useState(null)
    const [socialTemplateContents, setEmailTemplateContents] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const [headerScript, setHeaderScript] = useState(null)
    const [socialGalleryOption, setSocialGalleryOption] = useState({
        // instagram: false,
        sms: false,
        email: false,
        // linked_in: false,
        // facebook: false,
        // twitter: false,
        download: false,
        // snapchat:false, 
        // tiktok:false, 
        // signal:false, 
        // telegram:false
    })
    // const micro_site = history.location.state.micro_site

    const { register, handleSubmit, reset } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        

    })

    useEffect(()=>{
        
        http.get(`/event/microsite/get/${id}`)
            .then(res=>{
                let micro_site = res.data.microsite

                reset({
                    gallery_button: micro_site.gallery_button,
                    meta_title: micro_site.meta_title,
                    gallery_password: micro_site.gallery_password
                })

                setMicrositeData(micro_site)
                setMicroSite({ id: micro_site.microsite_gallery_id, template_image: micro_site.microsite_template_photo })
                setSocialGalleryOption({
                    // instagram: micro_site.instagram,
                    sms: micro_site.sms,
                    email: micro_site.email,
                    // linked_in: micro_site.linked_in,
                    // facebook: micro_site.facebook,
                    // twitter: micro_site.twitter,
                    download: micro_site.download,
                    // snapchat:micro_site.snapchat, 
                    // tiktok:micro_site.tiktok, 
                    // signal:micro_site.signal, 
                    // telegram:micro_site.telegram
                })

                if ("editedData" in history.location.state) {
                    const theData = history.location.state.editedData
                    // console.log(theData)
                    setMicroSite({id: theData.template.id, template_image:theData.template.image})
                    setEmailTemplateType(theData.saveAs)
                    setEmailTemplateContents(theData.content)
                    if (theData.saveAs == 'my_template') {
                        setSocialMyTemplateId(theData.my_social_gallery_id)
                    }
                    else{
                        setSocialMyTemplateId(null)
                    }
                }
            })
            .catch(err=>{
                console.log(err)
            })
    }, [id])


    const { fileURL, onChangeFile } = UploadFile()

    const handelMicroSite = async (data) => {
        const submittedData = { ...data, ...socialGalleryOption, microsite_gallery_id: microSite.id, microsite_template_photo: microSite.template_image, template_type: socialTemplateType, my_social_gallery_id, contents: socialTemplateContents, tag_script: headerScript }
        try {
            setLoading(true)
            await http.post(`/event/microsite/update/${id}`, submittedData).then((res) => {
                if (res) {
                    setLoading(false)
                    history.push(`/show/event/${microSiteData && microSiteData.event_id}`, 'Information Updated.')
                }
            })
        } catch (error) {

        }
    }


    const setMicrositeByProps = (data) => {
        if ('contents' in data) {
            setMicroSite({id: data.id, image: data.image})
            setEmailTemplateContents(data.contents)
            setEmailTemplateType('my_template')
            setSocialMyTemplateId(data.my_social_gallery_id)
        }
        else{
            setMicroSite(data)
        }
        setMicroSite(data)
    }

    const selectAllSocialSharign = () => {
        let checkbox = document.querySelector(".select-all-item");
        if (checkbox.checked) {
            setSocialGalleryOption({
                // instagram: true,
                sms: true,
                email: true,
                // linked_in: true,
                // facebook: true,
                // twitter: true,
                download: true,
                // snapchat:true,
                // tiktok:true,
                // signal:true,
                // telegram:true,
            })
        }
        else{
            setSocialGalleryOption({
                // instagram: false,
                sms: false,
                email: false,
                // linked_in: false,
                // facebook: false,
                // twitter: false,
                download: false,
                // snapchat:false, 
                // tiktok:false, 
                // signal:false, 
                // telegram:false
            })
        }
        
    }

    useEffect(()=>{
        if (typeof(history.location.state) != "undefined" && "editedData" in history.location.state) {
            const theData = history.location.state.editedData
            setMicroSite({id: theData.template.id, template_image:theData.template.template_image})
            setEmailTemplateType(theData.saveAs)
            setEmailTemplateContents(theData.content)
            if (theData.saveAs == 'my_template') {
                setSocialMyTemplateId(theData.email_my_template_id)
            }
            else{
                setSocialMyTemplateId(null)
            }
        }
    }, [history])

    const selectSocialGalleryItem = (e) => {
        let checkbox = document.querySelector(`input[name='${e.target.name}']`)

        if (checkbox.checked) {
            setSocialGalleryOption({...socialGalleryOption, [e.target.name]: true})
        }
        else{
            setSocialGalleryOption({...socialGalleryOption, [e.target.name]: false})
        }
    }

    const handleHeaderScript = (data) => {
        setHeaderScript(data)
    }

    return (
        <Layout>
            <NewFormWizard />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="pb-4">
                                            <p className="mb-0 display-4 text-primary event-form-title">Social Gallery</p>
                                            <p className="mb-0 text-secondary">Edit your online gallery settings</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(handelMicroSite)} >
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="py-4 bg-white border social__sharing__option__area radius-10">
                                        <div className="select-all d-flex align-items-center justify-content-between border-bottom">
                                            <h6 className="pl-2">Social Sharing Option</h6>
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="SMS" className="">Select All</label>
                                                <input type="checkbox" className="form-control focus-none select-all-item" onChange={selectAllSocialSharign} />
                                                <span class="checkmark"></span>
                                            </div>
                                        </div>
                                        <div className="flex-wrap d-flex justify-content-center">
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="SMS" className="">SMS</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.sms} name="sms" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Email" className="">Email</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.email} name="email" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="Facebook" className="">Facebook</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.facebook} name="facebook" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Instagram" className="">Instagram</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.instagram} name="instagram" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>



                                            <div className="icon__checkbox__area">
                                                <label htmlFor="LinkedIn" className="">Linkedin</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.linked_in} name="linked_in" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Twitter" className="">Twitter</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.twitter} name="twitter" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>
                                            
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="snapchat" className="">Snapchat</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.snapchat} name="snapchat" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}
                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="tiktok" className="">TikTok</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.tiktok} name="tiktok" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}
                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="signal" className="">Signal</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.signal} name="signal" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}
                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="telegram" className="">Telegram</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.telegram} name="telegram" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}


                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Download" className="">Download</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.download} name="download" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                    <h6 className="mb-4 text-center">Gallery Option</h6>
                                    <div className="p-3 bg-white form-group row ">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" {...register("gallery_button")} />
                                                </div>
                                            </div>
                                            <input type="text" class="form-control" aria-label="Text input with checkbox" style={{ color: 'rgb(206,162,82)' }} disabled value="Hide Gallery From Social Gallery" />
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="mt-4 row">
                                <div className="col-sm-6">
                                    <div className="py-3 card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-6 d-flex align-items-center flex-column justify-content-center">
                                                    <div className="place-holder-section">
                                                        {
                                                            !microSite ?
                                                                <div className="default-section">

                                                                    <h4>Choose Template.</h4>
                                                                </div>
                                                                :
                                                                <div className="default-section">
                                                                    <img src={`${URL_S3}image/micro_site/${microSite.template_image}`} className="img-fluid" alt="email-template" />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="my-auto col-sm-6">
                                                    <button type="button" className="btn btn-primary btn-block" data-toggle="modal" data-target="#micro-site">Social Gallery Template Library</button>
                                                    <button type="button" className="btn btn-secondary btn-block" onClick={e=> setOpenModal(true)}>Header Tracking</button>

                                                    <MicrositeModal setData={setMicrositeByProps} oldItem={microSiteData && microSiteData.microsite_gallery_id} micro_site={id} />

                                                    <HeaderTrackingModal 
                                                        isOpen={openModal} 
                                                        closeModal={setOpenModal} 
                                                        handleHeaderScript={handleHeaderScript}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="card">
                                        <div className="card-body" style={{minHeight: '350px'}}>
                                            {/* <div className="form-row">
                                                <div className="form-group col-md-9">
                                                    <div className="border rounded input-group">
                                                        <p className="m-2">Edit Social Messages</p>
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <div className="input-group attract__screen__upload ">
                                                        <label className="text-center custom-file-upload w-100">
                                                            <input type="button" value="Upload" style={{ border: 'none', background: 'none' }} />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group col-md-9">
                                                    <div className="border rounded input-group">
                                                        <p className="m-2">Slide show background (1920x1280)</p>
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <div className="input-group attract__screen__upload ">
                                                        <label className="text-center custom-file-upload w-100">
                                                            <input type="file" onChange={onChangeFile} />
                                                            Upload
                                                        </label>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <div className="form-group">
                                                <label htmlFor="">Meta Title</label>
                                                <div className="input-group">
                                                    <input type="text" className="form-control" {...register("meta_title")} />
                                                </div>
                                            </div> */}
                                            <div className="form-group">
                                                <label htmlFor="">Gallery Password</label>
                                                <div className="input-group">
                                                    <input type="password" className="form-control" placeholder="Gallery Password" {...register("gallery_password")} />
                                                </div>
                                                <small>Leave blank if you don't want the gallery password protected</small>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="my-5 row justify-content-center">
                                <div className="col-md-12">
                                    <button type="submit" className="float-right px-5 btn btn-primary radius-30">
                                        {loading ?
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Updating...
                                            </>
                                            : "Update"
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </section>
        </Layout>
    )
}

export default MicroSiteEdit
